// Packages
import PropTypes from 'prop-types'

// Components
import CustomerForm from 'modules/Customers/components/Form';

// Other
import useApi from 'hooks/useApi';

const CustomerCreateScreen = ({ onClose }) => {

    const { post: create, errors } = useApi('/customers', false)

    const submit = async (values) => {

        create(values, 'Customer created!', '/customers/')
    }

    return(
        <CustomerForm 
            errors={errors} 
            onClose={onClose} 
            onSubmit={submit} 
            type='create' 
        />
    )
}

CustomerCreateScreen.propTypes = {
	onClose: PropTypes.func,
}

CustomerCreateScreen.defaultProps = {
	onClose: () => {alert('onClose is not set!')},
}

export default CustomerCreateScreen;